import { DialogContent, Stack } from "@mui/material";
import {
  BottomSheet,
  Illustration,
  Text,
  Title,
  type UseModalState,
} from "@src/appV2/redesign/system/ui-components";
import { useCallback } from "react";

import { Button } from "../../components/Button";
import { DialogFooter } from "../../components/DialogFooter";

export type CancellationAlertAction = "send" | "cancel" | "goToBookings";

interface Props {
  modalState: UseModalState;
  onAction: (action: CancellationAlertAction) => void;
}

export function CancellationAlertModal(props: Props) {
  const { modalState, onAction } = props;

  const handleGoToBookings = useCallback(() => {
    onAction("goToBookings");
  }, [onAction]);

  const handleSend = useCallback(() => {
    onAction("send");
  }, [onAction]);

  const handleCancel = useCallback(() => {
    onAction("cancel");
  }, [onAction]);

  return (
    <BottomSheet
      modalState={modalState}
      canDismiss={false}
      footer={
        <DialogFooter orientation="vertical">
          <Button fullWidth size="large" variant="contained" onClick={handleGoToBookings}>
            Go to My Bookings
          </Button>
          <Button fullWidth size="large" variant="outlined" onClick={handleSend}>
            Send Message Anyway
          </Button>
          <Button fullWidth size="large" variant="outlined" onClick={handleCancel}>
            Don&apos;t Send
          </Button>
        </DialogFooter>
      }
    >
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          paddingTop: 9,
        }}
      >
        <Stack alignItems="center" spacing={4} sx={{ paddingX: 4 }}>
          <Illustration type="warning" data-testid="warning-illustration" />
          <Title variant="h3" component="h3" sx={{ textAlign: "center" }}>
            Do you need to cancel a shift?
          </Title>
          <Text variant="body1" align="center" color="text.secondary">
            It looks like you might be asking the workplace to cancel a shift. If so, please cancel
            via the My Bookings page. Asking workplaces to cancel slows down the search for a
            replacement, and repeated reports can result in an automatic cancellation with standard
            Clipboard Score penalties applied.
          </Text>
        </Stack>
      </DialogContent>
    </BottomSheet>
  );
}
